module.exports = __webpack_public_path__ + "static/media/TPL-Discrepancy.e8ecfde0.pdf";